import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement("svg", { width: 8, height: 6, viewBox: "0 0 8 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ e.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.35615 0.149062C7.54997 0.345758 7.54763 0.662332 7.35094 0.856149L2.9406 5.20195L0.649062 2.94394C0.452366 2.75012 0.450033 2.43355 0.643851 2.23685C0.837669 2.04016 1.15424 2.03782 1.35094 2.23164L2.9406 3.79805L6.64906 0.143851C6.84576 -0.0499671 7.16233 -0.047634 7.35615 0.149062Z" }));
export {
  l as default
};
//# sourceMappingURL=index.es2500.js.map
